import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, TOKEN_KEY } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem(TOKEN_KEY)) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const applyAuth = (data) => {
    localStorage.setItem(TOKEN_KEY, data.token);
    localStorage.setItem("ga_onboarded", "1");
    setUser(data.user);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.two_factor_required) return data;
    applyAuth(data);
    return data;
  };
  const register = async (payload) => { const { data } = await api.post("/auth/register", payload); applyAuth(data); return data; };
  const registerUsername = async (payload) => { const { data } = await api.post("/auth/register/username", payload); applyAuth(data); return data; };
  const completeTwoFactor = async (challenge, code, rememberDevice) => applyAuth((await api.post("/auth/2fa/verify", { challenge, code, remember_device: rememberDevice })).data);
  const logout = () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) api.post("/auth/logout", null, { headers: { Authorization: `Bearer ${token}` } }).catch(() => {});
    localStorage.removeItem(TOKEN_KEY);
    setUser(null);
  };
  const updateUser = async (payload) => {
    const { data } = await api.put("/users/me", payload);
    setUser(data);
    return data;
  };

  return <AuthContext.Provider value={{ user, loading, login, register, registerUsername, completeTwoFactor, logout, updateUser, setUser, refresh }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
